import { useKeyboardNavigation } from '../../lib/hooks/useKeyboardNavigation';

// This component's purpose is to use the useKeyboardNavigation without
// having to refactor TileStateManager.js
// If TilesStateManager.js becomes a functional component, this can be moved to it.
export const FullSizeTileNavigationWrapper = ({
  arrowLeftRef,
  arrowRightRef,
  children,
}) => {
  useKeyboardNavigation({
    arrowLeftRef,
    arrowRightRef,
  });

  return children;
};
